import { useContext, useState } from "react";
import { useNavigate } from 'react-router-dom'
import { ClickAwayListener, Popper, Paper, ListItemButton, ListItemIcon, ListItemText, SvgIcon} from "@mui/material";
import { AuthContext } from '../../../contexts/auth/authContext'
import { DataContext, DataDispatchContext } from '../../../contexts/data/dataContext'
import { 
    profileIconPath,
    questionIconDefault,
    questionIconSelected,
    signOutIconPath,
    houseIconDefault,
    houseIconSelected
  } from '../../common/iconPaths'
import custom from '../../../styles/mui/szVariables.json'
import { clickAnalyticsProfile } from '../../common/util/util'

export default function ProfileContextMenu({ setPopperState, anchorEl }: any) {
    const data = useContext(DataContext)
    const dispatch: any = useContext(DataDispatchContext)
    const auth = useContext(AuthContext)
    const navigate = useNavigate()  
    const [selected, setSelected] = useState(data?.acctSelected || 'details');
    const colorSelected = 'primary.main'

    const handleMenuClick = (event: any) => {
        const id = `${event.currentTarget.id}`.replace('Context','')
        setSelected(id)
        dispatch({
            type: 'setAcctSelected',
            acctSelected: id
        })
        clickAnalyticsProfile(id)
        navigate('/profile')
        if('signout'===id) {
          auth.signOut()
          .then(()=>navigate('/signin'))
          .finally(()=>navigate('/signin'))
        }
      }
  
      const navItemList = [
        {
            id: 'details',
            name: data?.customer?.name,
            subTitle: data?.customer?.email,
            iconPath: profileIconPath,
            selected: profileIconPath,
            action: handleMenuClick
        },
        {
            id: 'system',
            name: "Your system",
            iconPath: houseIconDefault,
            selected: houseIconSelected,
            action: handleMenuClick
        },
        {
            id: 'help',
            name: "Help & support",
            iconPath: questionIconDefault,
            selected: questionIconSelected,
            action: handleMenuClick
        },
        {
            id: 'signout',
            name: "Sign out",
            iconPath: signOutIconPath,
            selected: signOutIconPath,
            action: handleMenuClick
        }
      ]

      const menuItems = (items: any[]) => (
        <>
          {items.map((item: any, i: number)=>(
            <ListItemButton id={`${item.id}Context`} key={item.id} 
              onClick={(event)=>{
                item.action(event)
                setPopperState(null)
              }} 
              sx={{ 
                    height: item.subTitle?custom.sizes.xxl:'52px',
                    borderBottom: item.subTitle? custom.border: 'none', 
                    '&:hover': {
                      backgroundColor: 'sz.colors.hover',
                      boxShadow: 'none',
                      borderRadius: i===0?'16px 16px 0 0':
                                    i===(items.length-1)?'0 0 16px 16px':0                                             
                    }
                  }}
              >
            <ListItemIcon>
                <SvgIcon viewBox="0 0 24 24" 
                    sx={{ 
                        color: `${item.id===selected?colorSelected:
                                item.id!=='signout'?'inherit':'error.main'}`,
                            pt: "1px" 
                        }}> {item.id===selected?item.selected:item.iconPath} 
                </SvgIcon>
            </ListItemIcon>
              <ListItemText 
                    primary={item.name} 
                    primaryTypographyProps={{
                        textAlign: "left", 
                        color: `${item.id===selected?colorSelected:
                                    item.id!=='signout'? 'inherit':'error.main'}` , 
                        variant: 'szHeading.Regular.xxSmall',
                        ml: '-25px',
                        noWrap: true,
                    }}
                    secondary={item.subTitle}
                    secondaryTypographyProps={{
                        textAlign: "left", 
                        color: `${item.id===selected?colorSelected:'inherit'}` , 
                        variant: 'szBody.Regular.xSmall',
                        pr: '75px',
                        ml: '-25px',
                        noWrap: true,
                        width: "190px"
                    }}
                  />
                    
            </ListItemButton>
          ))}
        </>
      )

    return (
        <Popper id={"energySavingsModeMenu"} 
            open={Boolean(anchorEl)} anchorEl={anchorEl}  
            style={{zIndex: 10000}}
            >
            <ClickAwayListener onClickAway={()=>setPopperState(null)}>
            <Paper sx={{
                    mt: custom.spacing.md,
                    width: "254px", 
                    borderRadius: custom.corners5, 
                    background: '#FFF',

                }} elevation={10}>
                {menuItems(navItemList)}
            </Paper>
            </ClickAwayListener>
        </Popper>
    )
}